import { az } from "../../../../date-fns/locale/az.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    az
  }
};